<template>
  <el-breadcrumb
    class="mes-breadcrumb"
    separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item, index) in levelList"
        :key="item.path">
        <span
          v-if="index === levelList.length - 1"
          class="no-redirect">
          {{ item.meta.title }}
        </span>
        <a
          v-else
          @click.prevent="handleLink(item, index)">
          {{ item.meta.title }}
        </a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null
    };
  },
  watch: {
    // 监听router变化
    $route(route) {
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    // 获取面包屑
    getBreadcrumb() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
    },
    // 跳转链接
    handleLink(item, index) {
      let { redirect, path } = item;
      if (redirect) {
        if (redirect.startsWith('/iframe') && redirect.indexOf('?redirect=') === -1) {
          redirect = this.levelList[index + 1].redirect;
        }
        this.$router.push(redirect);
        return;
      }
      const reg = /:id/;
      if (reg.test(path)) {
        const id = this.$route.params.id;
        path = path.replace(reg, id);
      }
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss">
@include b(breadcrumb) {
  display: inline-block;
  margin-left: 8px;
  .no-redirect {
    color: $color-text-secondary;
    cursor: text;
  }
}
</style>